// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"ReviewForm_TextArea__1-wrY","InputText":"ReviewForm_InputText__-w39T","SubmitButton":"ReviewForm_SubmitButton__1hNGp"};